import { Component, Input, OnInit } from '@angular/core';
import { ReportBase } from '../report.base';
import { ReportsService } from '../../../../services';
import { Store } from '@ngrx/store';
import { AppState, map, finalize, DownloadUtil, DateUtil } from '../../../../store';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { orderBy, sortBy, uniq, uniqBy } from 'lodash';
import * as lodash from 'lodash';

@Component({
  selector: 'app-reconciliation-report',
  templateUrl: './reconciliation-report.component.html',
  styleUrls: ['./reconciliation-report.component.css']
})
export class ReconciliationReportComponent extends ReportBase implements OnInit {
  controls = [];

  @Input() bank = '';
  constructor(
    public service: ReportsService,
    public store: Store<AppState>,
    public loadingService: Ng4LoadingSpinnerService
  ) {
    super(service, store, loadingService);
  }

  ngOnInit() {
    if (!this.bank) {
      this.pullData('getReconciliationReportData');
    } else {
      this.loadingService.show();
      this.service.getReconciliationBankReportDataNew(this.bank).pipe(
        map((res: any) => (res.list = orderBy(res.list, 'created', 'desc'), res)),
        finalize(() => {
          if (this.loadingService) {
            this.loadingService.hide();
          }
        })
      ).subscribe((res: any) => {
        if (res && res['list']) {
          let temp = res.list;
          this.report = res;
          this.setData(temp);

          this._reports = res['list'].slice();
          this.checked = new Array(this.reportsList.length).fill(false);
          this.usersList = uniqBy(res.list.filter(item => item.email && item.childFirstName).map(item => ({
            email: item.email,
            name: `${item.childFirstName} ${item.childLastName}`
          })), 'email');

          if (this.controls) {
            const cardType = this.controls.find(c => c.name === 'cardtype');
            if (cardType) {
              cardType.options = uniq<string>(this.report.map(r => r.cardtype)).map(t => ({ value: t, text: t }));
            }

            this.updateControls();
          }
        }
      });
    }
  }

  setData(newData: any[]): any {
    newData.forEach((a: any) => {
      this.reportsList.push(a);
    })
  }
  updateControls() {
    this.controls = [
      { name: 'startDate', type: 'cdate', title: 'Start Date' },
      { name: 'endDate', type: 'cdate', title: 'End Date' },
      { name: 'transactionID', type: 'text', title: 'Transaction ID' },
      { name: 'childFirstName', type: 'text', title: 'First Name' },
      { name: 'childLastName', type: 'text', title: 'Last Name' },
    ];
    super.updateControls();
  }

  export() {
    var userList = [];
    userList = lodash.orderBy(this.selectedUsersList, ['created'], 'desc');

    DownloadUtil.toCSV(
      userList.map(user => ({
        //'Type': ['Credit Card', 'Check', 'Cash'].indexOf(user.paymentType) > -1 ? 'Charge' : user.paymentType,
        'Item': user.programName,
        'Fee': user.feeName,
        'Source': user.sourceID,
        'Created': (user.created || '').slice(0, 10),
        'Amount': user.transactionAmount && user.transactionAmount < 0 ? `-$ ${this.getAmount((user.transactionAmount || 0).toFixed(2))}` : `$ ${this.getAmount((user.transactionAmount || 0).toFixed(2))}`,
        'Merchant Fee': user.merchantFee && user.merchantFee < 0 ? `-$ ${this.getAmount((user.merchantFee || 0).toFixed(2))}` : `$ ${this.getAmount((user.merchantFee || 0).toFixed(2))}`,
        'Net': user.net && user.net < 0 ? `-$ ${this.getAmount((user.net || 0).toFixed(2))}` : `$ ${this.getAmount((user.net || 0).toFixed(2))}`,
        'Member ID': user.childUserID,
        'Member Name': user.childFirstName + ' ' + user.childLastName,
        'Parent ID': user.parentID,
        'Parent Name': user.parentFirstName + ' ' + user.parentLastName,
        'Payout ID': user.stripePayoutID
      })),
      'reconciliation-report.csv'
    );
  }

  getAmount(amount: string): string {
    if (amount != null) {
      return amount.replace(/-/g, "");
    }
    else {
      return amount;
    }
  }

  search(f) {
    super.search(f);
    if (this.report && this.report.list) {
      this.report.list = this.report.list.filter(x =>
        (!f.startDate || new Date(x.paidDate).getTime() >= new Date(f.startDate).getTime()) &&
        (!f.endDate || new Date(x.paidDate).getTime() <= new Date(f.endDate).getTime())
      );
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/reconciliation-report/reconciliation-report.component.ts